export const environment = {
	VERSION: 'DEV',
	DEBUG_INFO_ENABLED: true,
	config: {
		httpclient: {
			timeout: 10000,
		},
	},
	ws: {
		// erp: 'http://192.168.100.254:8001', //whatsapp
		// erpWs: 'http://192.168.100.254:8090', //socket
		// erp: 'http://localhost:8001',
		// erpWs: 'http://localhost:8090',
		// erp: 'http://127.0.0.1:8001',
		erp: 'http://erp.vibra-stop.com.br:8291', // whatsapp
		erpWs: 'http://erp.vibra-stop.com.br:8191', // socket
	},
};
